import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import './LTButton.css';

interface LTButtonProps {
  /**
   * FontAwesome icon name (e.g., "search", "bars", "cog")
   */
  icon: IconProp;
  
  /**
   * Button title/tooltip text
   */
  text?: string;
  title?: string;
  
  /**
   * Click handler function
   */
  onClick?: () => void;
  
  /**
   * Additional CSS classes
   */
  className?: string;
  
  /**
   * Button type attribute
   */
  type?: 'button' | 'submit' | 'reset';
  
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;
  
  /**
   * Additional props for accessibility and data attributes
   */
  [key: string]: any;
}

/**
 * LTButton - A theme-friendly button component with FontAwesome icon
 * Uses lt-btn class for consistent styling with header-btn appearance
 */
const LTButton: React.FC<LTButtonProps> = ({
  icon,
  title,
  text,
  onClick,
  className = '',
  type = 'button',
  disabled = false,
  ...otherProps
}) => {
  return (
    <>
    <button
      type={type}
      className={`lt-btn ${className}`.trim()}
      title={title}
      onClick={onClick}
      disabled={disabled}
      {...otherProps}
    >
      <FontAwesomeIcon icon={icon} />{text}
    </button>
    </>
  );
};

export default LTButton;